import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Injectable } from "@angular/core";

@Injectable()
export class PreloadAllModulesWithDelay implements PreloadingStrategy {
    preload(route: Route, fn: () => Observable<any>): Observable<any> {
        // Load lazy modules after a X seconds delay after the initial load
        return timer(2000 + Math.random() * 3000).pipe(switchMap(() => fn().pipe(catchError(() => of(null)))));
    }
  }
